(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-format-picker"] && !Shopify.designMode) return;
  try {
    
  /*
   * Product Format Picker cart wiring
   * Adds the main product (and optional addon) to cart, then opens the cart drawer.
   * Existing automatic discount applies the bundled price for Bundle + Workbook.
   * (c) Alpas Made LLC
   */
  (function () {
    function buildItems(button) {
      var card = button.closest('.format-card');
      var items = [];
      var primaryId = button.getAttribute('data-product-variant-id');
      if (primaryId) items.push({ id: parseInt(primaryId, 10), quantity: 1 });
      if (card) {
        var addon = card.querySelector('[data-format-card-addon]');
        if (addon && addon.checked) {
          var label = addon.closest('.format-card__addon');
          var addonId = label ? label.getAttribute('data-addon-variant-id') : null;
          if (addonId) items.push({ id: parseInt(addonId, 10), quantity: 1 });
        }
      }
      return items;
    }

    function setBusy(button, busy) {
      if (busy) {
        button.classList.add('is-busy');
        button.setAttribute('aria-busy', 'true');
        button.setAttribute('disabled', 'disabled');
      } else {
        button.classList.remove('is-busy');
        button.removeAttribute('aria-busy');
        button.removeAttribute('disabled');
      }
    }

    function openCartDrawer() {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.show === 'function') drawer.show();
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }

    function showError(button, message) {
      var card = button.closest('.format-card');
      if (!card) return;
      var existing = card.querySelector('[data-format-card-error]');
      if (existing) return;
      var note = document.createElement('div');
      note.setAttribute('data-format-card-error', '');
      note.setAttribute('role', 'alert');
      note.style.color = '#e11d48';
      note.style.fontSize = '12px';
      note.style.marginTop = '8px';
      note.textContent = message;
      button.parentNode.insertBefore(note, button.nextSibling);
    }

    function handleClick(event) {
      var button = event.currentTarget;
      var items = buildItems(button);
      if (items.length === 0) return;
      event.preventDefault();
      setBusy(button, true);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart add failed: ' + response.status);
          return response.json();
        })
        .then(function () {
          openCartDrawer();
        })
        .catch(function (error) {
          console.error('[FormatPicker]', error);
          showError(button, 'Could not add to cart. Please try again.');
        })
        .then(function () {
          setBusy(button, false);
        });
    }

    function syncDynamicPricing(card) {
      if (!card) return;
      var addon = card.querySelector('[data-format-card-addon]');
      var checked = addon ? addon.checked : false;
      var priceEl = card.querySelector('[data-format-card-price]');
      if (priceEl) {
        var base = priceEl.getAttribute('data-base-price') || '';
        var bundled = priceEl.getAttribute('data-bundled-price') || '';
        var next = checked && bundled ? bundled : base;
        if (priceEl.textContent !== next) priceEl.textContent = next;
      }
      var ctaText = card.querySelector('[data-format-card-cta-text]');
      var cta = card.querySelector('[data-format-card-cta]');
      if (cta) {
        var baseLabel = cta.getAttribute('data-base-label') || '';
        var bundledLabel = cta.getAttribute('data-bundled-label') || '';
        var nextLabel = checked && bundledLabel ? bundledLabel : baseLabel;
        if (ctaText && ctaText.textContent !== nextLabel) ctaText.textContent = nextLabel;
      }
    }

    function handleAddonToggle(event) {
      var card = event.currentTarget.closest('.format-card');
      syncDynamicPricing(card);
    }

    function init() {
      var buttons = document.querySelectorAll('[data-format-card-cta]');
      buttons.forEach(function (button) {
        if (button.dataset.formatCardBound === 'true') return;
        button.dataset.formatCardBound = 'true';
        button.addEventListener('click', handleClick);
      });
      var addons = document.querySelectorAll('[data-format-card-addon]');
      addons.forEach(function (addon) {
        if (addon.dataset.formatCardBound === 'true') return;
        addon.dataset.formatCardBound = 'true';
        addon.addEventListener('change', handleAddonToggle);
        // Sync on load in case Shopify restored a checked state.
        syncDynamicPricing(addon.closest('.format-card'));
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);

    // ===========================================================
    // Format Picker upsell modal - SELF-CONTAINED
    // No dependency on the Rich Text Upsell section. Each section
    // instance renders its own modal with its own scoped DOM, and
    // the click handler resolves the correct modal via the trigger's
    // ancestor shopify-section. Class is .upsell-trigger-card (NOT
    // .upsell-trigger) so #open-upsell hash links continue targeting
    // the Rich Text Upsell button only.
    // ===========================================================
    function fpuFindModal(trigger) {
      var section = trigger.closest('.shopify-section');
      if (section) {
        var inSection = section.querySelector('[data-fpu-modal]');
        if (inSection) return inSection;
      }
      return document.querySelector('[data-fpu-modal]');
    }

    function fpuOpenModal(trigger) {
      var modal = fpuFindModal(trigger);
      if (!modal) {
        console.warn('[format-picker] No upsell modal found in DOM.');
        return;
      }
      var heading = modal.querySelector('[data-fpu-heading]');
      var subheading = modal.querySelector('[data-fpu-subheading]');
      var savings = modal.querySelector('[data-fpu-savings]');
      var image = modal.querySelector('[data-fpu-image]');
      var acceptBtn = modal.querySelector('[data-fpu-accept]');
      var declineBtn = modal.querySelector('[data-fpu-decline]');

      var ds = trigger.dataset;
      var defaultProductId = ds.defaultProductId || '';
      var upsellProductId = ds.upsellProductId || '';
      var imgUrl = ds.upsellProductImage || '';
      var primaryText = ds.primaryText || 'Yes, add it';
      var secondaryText = ds.secondaryText || 'No thanks';

      heading.textContent = ds.upsellHeading || '';
      subheading.textContent = ds.upsellSubheading || '';
      savings.textContent = ds.upsellSavings || '';
      acceptBtn.textContent = primaryText;
      declineBtn.textContent = secondaryText;

      if (imgUrl) {
        image.src = imgUrl;
        image.alt = ds.upsellHeading || '';
        image.style.display = 'block';
      } else {
        image.removeAttribute('src');
        image.style.display = 'none';
      }

      acceptBtn.disabled = false;
      declineBtn.disabled = false;

      // Click-handlers reset each open via .onclick (no stacking).
      acceptBtn.onclick = function () { fpuCheckout(acceptBtn, primaryText, defaultProductId, upsellProductId); };
      declineBtn.onclick = function () { fpuCheckout(declineBtn, secondaryText, defaultProductId, ''); };

      modal.classList.add('is-active');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function fpuCloseModal(modal) {
      modal.classList.remove('is-active');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function fpuCheckout(btn, originalLabel, defaultId, upsellId) {
      btn.disabled = true;
      btn.textContent = 'Adding...';

      function reset(msg) {
        btn.disabled = false;
        btn.textContent = originalLabel;
        if (msg) alert(msg);
      }

      function addItem(id) {
        if (!id) return Promise.resolve();
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
        }).then(function (res) {
          if (!res.ok) throw new Error('Cart add failed: ' + res.status);
          return res.json();
        });
      }

      fetch('/cart/clear.js', { method: 'POST' })
        .then(function () { return addItem(defaultId); })
        .then(function () { return addItem(upsellId); })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function (err) {
          console.error('[format-picker] Checkout error:', err);
          reset('Could not add to cart. Please try again.');
        });
    }

    // If the card has an addon checkbox AND it's checked, the shopper has
    // already opted in to the upsell inline. Skip the modal nag and add
    // both items straight to cart -> checkout. Otherwise open the modal as
    // a "one more chance" prompt.
    function fpuAddonChecked(trigger) {
      var card = trigger.closest('.format-card');
      if (!card) return null;
      var addon = card.querySelector('[data-format-card-addon]');
      if (!addon || !addon.checked) return null;
      var label = addon.closest('.format-card__addon');
      var addonVariantId = label ? label.getAttribute('data-addon-variant-id') : null;
      return addonVariantId || null;
    }

    function fpuDirectCheckout(trigger, addonVariantId) {
      var defaultId = trigger.dataset.defaultProductId || '';
      trigger.classList.add('is-busy');
      trigger.setAttribute('aria-busy', 'true');
      trigger.setAttribute('disabled', 'disabled');

      function reset() {
        trigger.classList.remove('is-busy');
        trigger.removeAttribute('aria-busy');
        trigger.removeAttribute('disabled');
      }

      function addItem(id) {
        if (!id) return Promise.resolve();
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
        }).then(function (res) {
          if (!res.ok) throw new Error('Cart add failed: ' + res.status);
          return res.json();
        });
      }

      fetch('/cart/clear.js', { method: 'POST' })
        .then(function () { return addItem(defaultId); })
        .then(function () { return addItem(addonVariantId); })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function (err) {
          console.error('[format-picker] Direct checkout error:', err);
          reset();
          alert('Could not add to cart. Please try again.');
        });
    }

    if (!window.__fpuModalBound) {
      window.__fpuModalBound = true;

      // Open: delegated click on any .upsell-trigger-card.
      document.addEventListener('click', function (e) {
        var trigger = e.target && e.target.closest ? e.target.closest('.upsell-trigger-card') : null;
        if (trigger) {
          e.preventDefault();
          var addonId = fpuAddonChecked(trigger);
          if (addonId) {
            // User already opted in via the inline addon checkbox -> skip modal.
            fpuDirectCheckout(trigger, addonId);
          } else {
            fpuOpenModal(trigger);
          }
          return;
        }
        // Intentionally no backdrop-click, X-button, or Escape close: the
        // trigger is a buy button, so reaching this modal means the visitor has
        // committed to checkout. The only exits are the two action buttons,
        // both of which proceed to checkout.
      });

      // bfcache restore: returning from checkout via the browser back button
      // restores a frozen DOM snapshot. fpuOpenModal already re-enables the
      // accept/decline buttons on open, but the body scroll-lock and any
      // open modal can persist. Reset both so the page is usable again.
      window.addEventListener('pageshow', function (e) {
        if (!e.persisted) return;
        var open = document.querySelectorAll('[data-fpu-modal].is-active');
        open.forEach(function (m) { fpuCloseModal(m); });
        document.body.style.overflow = '';
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
